/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxInstanceResponse } from './LootBoxInstanceResponse';
import {
    LootBoxInstanceResponseFromJSON,
    LootBoxInstanceResponseFromJSONTyped,
    LootBoxInstanceResponseToJSON,
    LootBoxInstanceResponseToJSONTyped,
} from './LootBoxInstanceResponse';

/**
 * 
 * @export
 * @interface OpenLootBoxInstanceResponse
 */
export interface OpenLootBoxInstanceResponse {
    /**
     * 
     * @type {LootBoxInstanceResponse}
     * @memberof OpenLootBoxInstanceResponse
     */
    instance: LootBoxInstanceResponse;
    /**
     * 
     * @type {string}
     * @memberof OpenLootBoxInstanceResponse
     */
    prizeName: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLootBoxInstanceResponse
     */
    prizeImage?: string;
    /**
     * Pre-resolved display URL for the won prize (reward graphic, or a GIFT_CARD's brand card art).
     * @type {string}
     * @memberof OpenLootBoxInstanceResponse
     */
    prizeImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLootBoxInstanceResponse
     */
    prizeWonId: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLootBoxInstanceResponse
     */
    promoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenLootBoxInstanceResponse
     */
    promoName?: string;
}

/**
 * Check if a given object implements the OpenLootBoxInstanceResponse interface.
 */
export function instanceOfOpenLootBoxInstanceResponse(value: object): value is OpenLootBoxInstanceResponse {
    if (!('instance' in value) || value['instance'] === undefined) return false;
    if (!('prizeName' in value) || value['prizeName'] === undefined) return false;
    if (!('prizeWonId' in value) || value['prizeWonId'] === undefined) return false;
    return true;
}

export function OpenLootBoxInstanceResponseFromJSON(json: any): OpenLootBoxInstanceResponse {
    return OpenLootBoxInstanceResponseFromJSONTyped(json, false);
}

export function OpenLootBoxInstanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenLootBoxInstanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'instance': LootBoxInstanceResponseFromJSON(json['instance']),
        'prizeName': json['prizeName'],
        'prizeImage': json['prizeImage'] == null ? undefined : json['prizeImage'],
        'prizeImageUrl': json['prizeImageUrl'] == null ? undefined : json['prizeImageUrl'],
        'prizeWonId': json['prizeWonId'],
        'promoCode': json['promoCode'] == null ? undefined : json['promoCode'],
        'promoName': json['promoName'] == null ? undefined : json['promoName'],
    };
}

export function OpenLootBoxInstanceResponseToJSON(json: any): OpenLootBoxInstanceResponse {
    return OpenLootBoxInstanceResponseToJSONTyped(json, false);
}

export function OpenLootBoxInstanceResponseToJSONTyped(value?: OpenLootBoxInstanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instance': LootBoxInstanceResponseToJSON(value['instance']),
        'prizeName': value['prizeName'],
        'prizeImage': value['prizeImage'],
        'prizeImageUrl': value['prizeImageUrl'],
        'prizeWonId': value['prizeWonId'],
        'promoCode': value['promoCode'],
        'promoName': value['promoName'],
    };
}

